import { Component, Input, OnInit, ViewChild, ComponentFactoryResolver, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

import { HeaderHostDirective } from './header-host.directive';

import { HeaderService } from './header.service';

import { IHeader, HeaderItem } from './header';

@Component({
  selector: 'db-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input('headerTitle') headerTitle: string;
  @Input('headerSize') headerSize: ('h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6');
  @Input('headerType') headerType: ('main' | 'section');
  @Input('headerClass') headerClass: ('primary' | 'secondary' | 'success' | 'warning' | 'danger');

  @ViewChild(HeaderHostDirective, { static: true }) headerHost: HeaderHostDirective;

  subscriptionManager = new Subscription();

  constructor(
    private headerService: HeaderService,
    private componentFactoryResolver: ComponentFactoryResolver
  ) {

    const headerConfigSubscription = this.headerService.headerConfig$
      .subscribe((headerItems: HeaderItem) => {
        this.loadComponent(headerItems);
      });

    this.subscriptionManager
      .add(headerConfigSubscription);
  }

  ngOnInit() {
    if (!this.headerTitle) {
      this.headerTitle = 'Document Builder';
    }
  }

  loadComponent(headerItems: HeaderItem) {
    const componentFactory = this.componentFactoryResolver.resolveComponentFactory(headerItems.component);
    const viewContainerRef = this.headerHost.viewContainerRef;

    viewContainerRef.clear();

    const componentRef = viewContainerRef.createComponent(componentFactory);

    (<IHeader>componentRef.instance).data = headerItems.data ? headerItems.data : null;
  }

  ngOnDestroy() {
    /**
     * @description Unsubscribe from all subscriptions
     * to prevent memory leaks
     */
    this.subscriptionManager.unsubscribe();
  }

}
